import React from 'react';
import {getContainer} from '../../ioc/IOCSetup';
import "../SportsView.scss";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import Page from "../../layout/Page";
import {fetchSettings} from "../../settings/SettingsActions";
import {AppState} from "../../RootReducer";
import {LaunchUrl, Settings} from "../../http/protocol";
import {LoginStatus} from '../../http/Types';
import {ContentModelName, PopupManager} from "../../contenful/types";
import {fetchContent} from "../../contenful/ContentfulActions";
import {ReactComponent as Spinner} from "../../assets/ball_loader.svg";
import {progressBar} from "../../utils/ProgressBar";
import {Redirect, withRouter, RouteComponentProps} from 'react-router';
import { Device } from '../../utils/Device';
import { PATH } from '../../onboardingpage/modalview/UserModalController';


interface Props extends RouteComponentProps {
    settings : Settings,
    fetchSettings : typeof fetchSettings,
    loggedIn?: boolean;
    currency?: string;
    popupManager?: PopupManager;
    fetchContent : typeof fetchContent;
    lng: string;
};

interface State {
    sportsbookUrl?: string|undefined;
    iframeHeight?: number;
    loading:boolean;
    // hideAfterWentToOtherPage: boolean;
    progress:number;
    manualProgressIncrease:boolean;
    loginToBet:boolean;
}

export class UltraplaySportsComponent extends React.Component<Props, State>{
    resizeListener: any
    messageListener: any

    progressInterval : any;
    constructor(props : Props){
        super(props);
        let heightOffset = 80;
        if(window.innerWidth <= 1200) {
            heightOffset = 110;
        }
        this.state = { iframeHeight : window.innerHeight-heightOffset, loading:true, progress: 0, manualProgressIncrease:true, loginToBet:false };


    }

    componentDidMount(): void {
        setTimeout(() => {
            this.setState({loading:false})
        },30000)
        this.startProgress();

        this.messageListener = window.addEventListener("message", (e:any) => {
            if(e.data.funcName === "loginToPlaceBet" && !this.props.loggedIn) {
                return this.props.history.push({search: new URLSearchParams({type: PATH.LOGIN, modal: PATH.MODAL_TYPE}).toString()})
            } else if (e.data.funcName === "iframeItemsLoaded") {
                let iframe = document.getElementById("sportsbook-iframe");
                if(iframe) {iframe.style.visibility = "visible";}
                this.setState({progress: 100, manualProgressIncrease:false})
                setTimeout(()=>this.setState({loading:false, progress: 100, manualProgressIncrease:false}, () => clearInterval(this.progressInterval)),250)
            }
        });

        this.resizeListener = window.addEventListener("resize", ()=> {
            let heightOffset = 80;
            if(window.innerWidth <= 1200) {
                heightOffset = 110;
            }
            this.setState({iframeHeight:window.innerHeight-heightOffset})
        }, false)

        if(this.props.settings == undefined) {
            this.props.fetchSettings();
        }

        let locale = getContainer().getSettingsService().getActiveLocale().code;
        const currencyOnLoad = this.props.currency || "";

        if(this.props.loggedIn) {
            getContainer().getSportsbookService().getUltraplayGameLaunchUrl(currencyOnLoad, locale).then((r : LaunchUrl)=>{
                this.setState({ sportsbookUrl : r.url });
            });
        }
        if(!this.props.loggedIn) {
            getContainer().getSportsbookService().getUltraplayAnonymousGameLaunchUrl(locale).then((r : LaunchUrl)=>{
                this.setState({ sportsbookUrl : r.url });
            });
        }
    }
    startProgress () {
        let current_progress:number = 0;
        let step:number = 0.1;
        // this.setState({progress:0})
        this.progressInterval = setInterval(() => {
            if(this.state.manualProgressIncrease) {
                current_progress += step;
                let progress:number = Math.round(Math.atan(current_progress) / (Math.PI / 2) * 98 * 1000) / 1000;
                if(this.state.progress > 35) {
                    step = 0.4
                }
                this.setState({progress:progress})
            }
        }, 200);
    }

    async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        let locale = getContainer().getSettingsService().getActiveLocale().code;
        const curr:string = this.props.currency ||  "";

        // if(prevProps.loggedIn != this.props.loggedIn) {

        //     if(this.props.loggedIn) {
        //         getContainer().getSportsbookService().getUltraplayGameLaunchUrl(curr, locale).then((r : LaunchUrl)=>{

        //             this.setState({ sportsbookUrl : r.url , loading: true, progress : 0, manualProgressIncrease:true}, () => {
        //                 this.startProgress()
        //             });
        //         });
        //     } else {
        //         getContainer().getSportsbookService().getUltraplayAnonymousGameLaunchUrl(locale).then((r : LaunchUrl)=>{
        //             this.setState({ sportsbookUrl : r.url , loading: true, progress : 0, manualProgressIncrease:true}, () => this.startProgress());
        //         });
        //     }
        // }

        // if (!this.state.sportsbookUrl && (prevProps.loggedIn != this.props.loggedIn)) {

        //     if (this.props.loggedIn) {
        //         getContainer().getSportsbookService().getUltraplayGameLaunchUrl(curr, locale).then((r: LaunchUrl) => {
        //             this.setState({sportsbookUrl: r.url});
        //         });

        //     } else {
        //         getContainer().getSportsbookService().getUltraplayAnonymousGameLaunchUrl(locale).then((r: LaunchUrl) => {
        //             this.setState({sportsbookUrl: r.url});
        //         });
        //     }
        // }

        const loginChanged = prevProps.loggedIn != this.props.loggedIn
        const currencyChanged = prevProps.currency != this.props.currency

        if (loginChanged  ||  currencyChanged) {
            await this.setState({ sportsbookUrl: undefined, loading: true, progress : 0, manualProgressIncrease:true})

            let url;

            if (this.props.loggedIn  &&  this.props.currency) {
                url = await getContainer().getSportsbookService().getUltraplayGameLaunchUrl(this.props.currency, locale)
            } else {
                url = await getContainer().getSportsbookService().getUltraplayAnonymousGameLaunchUrl(locale)
            }
            
            await this.setState({ sportsbookUrl : url.url })
            this.startProgress()
        }

    }
    componentWillUnmount(): void {
        clearInterval(this.progressInterval);

        this.resizeListener  &&  window.removeEventListener("resize", this.resizeListener)
        this.messageListener  &&  window.removeEventListener("message", this.messageListener)

    }

    loadContent() {
        return(
            <iframe
                id="sportsbook-iframe"
                name="sportsbook-iframe"
                scrolling="no"
                width={"100%"}
                height={this.state.iframeHeight}
                className={`sportsbook-iframe ultraplay ${this.props.loggedIn ? 'authenticated' : 'anonymous'}`}
                frameBorder={0}
                allowFullScreen={false}
                src={this.state.sportsbookUrl}
            />
        )
    }

    render() {
        if(this.state.loginToBet) {
            /* return <Redirect to={"/playnow"} /> */
            return <Redirect to={{search: new URLSearchParams({type: "login", modal: "auth"}).toString()}} />
        }
        return (
            <div>
                {this.state.loading && <div className="preloader">
                    <Spinner/>
                    {progressBar(this.state.progress, "100px", "2px")}
                </div>}
                <Page>
                    {this.loadContent()}
                </Page>
            </div>
        )
    }
}

const stateToProps = (app : AppState) => {
    return {
        settings: app.settings.settings ? app.settings.settings : {},
        loggedIn : app.user.status == LoginStatus.LOGGED_IN,
        currency: app.user.activeCurrency,
        popupManager: app.contentful.popupManager,
    }
};

const dispatchToProps = (dispatch : Dispatch) => (
    {
        fetchSettings : () => dispatch(fetchSettings() as any),
        fetchContent : (contentModelName : ContentModelName) => dispatch(fetchContent(contentModelName) as any),

    }
);

const UltraplaySportsComponentWithRouter = withRouter(UltraplaySportsComponent);

export default connect(stateToProps, dispatchToProps)(UltraplaySportsComponentWithRouter)

